export const ROLE_USER = 'ROLE_USER'
export const ROLE_ADMIN = 'ROLE_ADMIN'
export const ROLE_SUPERVISOR = 'ROLE_SUPERVISOR'
export const ROLE_SALES = 'ROLE_SALES'
export const ROLE_CONTENT_ADMIN = 'ROLE_CONTENT_ADMIN'
